import { createStore } from "vuex";
import configure from "./configure";
import user from "./user";

export default createStore({
  modules: {
    configure,
    user,
  },
});
